import { render } from "./recentOrders.vue?vue&type=template&id=f0cbf8ea"
import script from "./recentOrders.vue?vue&type=script&lang=js"
export * from "./recentOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__